<template>
    <md-card-content>
        <template v-if="isGroupActive">
            <form ref="add_device_group_form" class="mb-4" @submit.prevent="addDeviceGroup">
                <span class="font-bold">Ajouter un groupement</span>
                <div class="md-layout">
                    <div class="md-layout-item md-size-75" style="padding-left: 0;">
                        <md-field class="md-invalid">
                            <label>Nom</label>
                            <md-input v-model="name" name="name" type="text" required></md-input>
                            <validation-error :errors="apiValidationErrors.name"/>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-25">
                        <md-button class="md-success" type="submit">Ajouter</md-button>
                    </div>
                </div>
            </form>
            <span class="font-bold">Liste des groupements</span>
            <md-table v-model="deviceGroups" table-header-color="blue" v-if="deviceGroups.length > 0">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="Nom" style="min-width: 275px;">
                        <span>{{ item.name }}</span>
                    </md-table-cell>
                    <md-table-cell md-label="Dispositifs">
                        <span>{{ item.devices.length }}</span>
                    </md-table-cell>
                    <md-table-cell md-label="">
                        <div class="flex items-center justify-end">
                            <div>
                                <md-button class="md-icon-button md-raised md-warning"
                                           @click="goToRoute('Site Device Group Edit', idSite, item.id)">
                                    <font-awesome-icon class="md-icon" :icon="['fas', 'pen']" />
                                </md-button>
                                <md-tooltip md-direction="top">Modifier</md-tooltip>
                            </div>
                            <div style="margin-left: .25rem;" v-if="item.devices.length === 0 && item.planning_intervention_previsions.length === 0">
                                <md-button class="md-icon-button md-raised md-danger"
                                    @click="handleDelete(item)">
                                    <font-awesome-icon class="md-icon" :icon="['fas', 'trash']" />
                                </md-button>
                                <md-tooltip md-direction="top">Supprimer</md-tooltip>
                            </div>
                        </div>
                    </md-table-cell>
                </md-table-row>
            </md-table>
            <p v-else>Aucun groupement sur ce site</p>
        </template>
        <template v-else>
            <p>Pas de gestion des groupements. Modifier les options du site pour l'activer.</p>
        </template>
    </md-card-content>
</template>

<script>
import formMixin from "@/mixins/form-mixin";
import {ValidationError} from "@/components";

export default {
    name: "DeviceGroups",
    components: {
        ValidationError
    },
    mixins: [formMixin],
    props: {
        idSite: Number,
        isGroupActive: Boolean,
        deviceGroups: Array,
    },
    data() {
        return {
            name: '',
        }
    },
    methods: {
        async addDeviceGroup() {
            this.resetApiValidation()
            try {
                await this.$store.dispatch('deviceGroups/addDeviceGroup', { idSite: this.idSite, name: this.name })
                await this.$store.dispatch('alerts/success', 'Groupement ajouté')
                this.$emit('added')
                this.name = ''
            } catch (e) {
                this.setApiValidation(e.response.data.errors)
            }
        },
        handleDelete(deviceGroup) {
            this.$swal.fire({
                title: "Êtes-vous sûr ?",
                html: `Voulez-vous supprimer le groupement <b>${deviceGroup.name}</b> ?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "md-button md-success",
                cancelButtonClass: "md-button md-warning",
                confirmButtonText: "Supprimer",
                cancelButtonText: "Annuler",
                buttonsStyling: false,
            }).then(async result => {
                if(result.value) {
                    try {
                        await this.$store.dispatch('deviceGroups/deleteDeviceGroup', { id: deviceGroup.id })
                        await this.$store.dispatch('alerts/success', 'Groupement supprimé')
                        this.$emit('deleted')
                    }
                    catch(e) {
                        let message = e.response.data.error ?? 'Suppression impossible'
                        await this.$store.dispatch("alerts/error", message)
                    }
                }
            });
        },
        goToRoute(route, idSite = null, deviceGroupId = null) {
            this.$router.push({ name: route, params: { idSite, deviceGroupId } })
        }
    }
}
</script>

<style scoped>

</style>
